define('common/collections/globals',['require','exports','module','base/collection','../models/global','env'],function(require, exports, module) {
  "use strict";

  var BaseCollection = require("base/collection"),
      Global = require("../models/global"),
      config = require("env");

  module.exports = BaseCollection.extend({
    model: Global,

    url: function() {
      return [config.apiHost, "variables", this.companyId].join("/");
    },

    parse: function(json, options) {
      return BaseCollection.prototype.parse.call(this, json.global, options);
    },

    toJSON: function(options) {
      return { global: BaseCollection.prototype.toJSON.call(this, options) };
    },

    initialize: function(models, options) {
      this.companyId = options.companyId;
      this.saveMethod = "patch";
    },

    addItem: function(){
      var newItem = new Global({
        name: "Global " + (this.length+1)
      });
      this.add(newItem);
      return newItem;
    },

    showHelp: function(e){
       var $this = $(e.target).parent();
       var url = $this.find('#globalsURLHelp').text();
       $this.attr('href', url);
    },

    save: function() {
      this.forEach(function(model){ model.set("id", model.cid, {silent: true}); });
      return Backbone.sync(this.saveMethod, this);
    },

    checkIfContentHasAGlobalVariable: function (content) {
      return !!content.match(/{{/g);
    },

    checkIfGlobalVariableHasTags: function (userScriptContent) {
      var scriptName = this.extractScriptNameIfIsGlobalVariable(userScriptContent),
        globalVariables = this.models;

      if (!globalVariables) {
        return false;
      }

      return !!globalVariables.filter(function (globalVar) {
        return (globalVar.get('name') === scriptName) && (globalVar.get('isTag'));
      }).length;
    },

    extractScriptNameIfIsGlobalVariable: function (name) {
      var result = name.match(/{{([^)]+)}}/);
      return (result && result[1]) || name;
    }
  });

});


